import React, { useState } from 'react';
import type { Club } from '@iziping/common';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGetClubs } from './clubHooks';
import { Building2, Search } from 'lucide-react';
import { EmptyState, InputIcon } from '@iziping/ui';

const ClubListPage: React.FC = () => {
    const { t } = useTranslation();

    const [searchTerm, setSearchTerm] = useState('');
    const { data: clubs, isError: isError, isLoading: isLoading } = useGetClubs();

    const navigate = useNavigate();

    const handleItemClick = (clubId: number) => {
        navigate(`/clubs/${clubId}`);
    };

    if (isLoading) return <div>Loading...</div>;
    if (isError) return <div>Error fetching data</div>;

    const filteredClubs = (clubs ?? []).filter((club: Club) =>
        club.name?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className={'page'}>
            <h3>{t('CLUB_LIST')}</h3>
            <InputIcon
                icon={Search}
                placeholder={t('common.search') as string}
                value={searchTerm}
                small={true}
                onChange={(e) => setSearchTerm(e.target.value)}
            />
            {filteredClubs.length > 0 ? (
                <table className={'table-stripped'}>
                    <thead>
                        <tr>
                            <th>{t('CLUB_NAME')}</th>
                            <th>{t('CLUB_NUMBER')}</th>
                            <th>{t('CLUB_DEPARTMENT')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredClubs.map((club: Club) => (
                            <tr key={club.id} onClick={() => handleItemClick(club.id)}>
                                <td>{club.name}</td>
                                <td>{club.number}</td>
                                <td>{club.department}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                <EmptyState
                    icon={<Building2 size={56} />}
                    message={t(searchTerm ? 'clubs.search.empty' : 'clubs.empty')}
                />
            )}
        </div>
    );
};

export default ClubListPage;
